const pmeta = {
  "pmeta.min": "min.",
  "pmeta.anes_local": "Anestezi lokale",
  "pmeta.anes_general": "Anestezi e përgjithshme",
  "pmeta.anes_none": "Asnjë",
  "pmeta.sessions_1": "1 takim",
  "pmeta.sessions_2": "2 takime",
  "pmeta.sessions_1_2": "1–2 takime",
  "pmeta.sessions_2_3": "2–3 takime",
  "pmeta.sessions_ongoing": "Në vazhdim",
};

export default pmeta;
